(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-5050-allfloors"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   KV · VIDEO EDITORIAL EN BUCLE  (bloques 50/50 y two-up)
   --------------------------------------------------------------------------
   Las cinco secciones kv-5050-* / kv-twoup incluyen este MISMO bloque; el flag
   de window hace que solo arranque el primer ejemplar que llegue.
     · Arranca por IntersectionObserver y PAUSA al salir de pantalla.
     · prefers-reduced-motion: no reproduce nada, se queda en el poster.
     · El poster esta siempre puesto: si el mp4 no carga se ve la imagen y no
       un hueco negro.
   ========================================================================== */
(function () {
  if (window.kvEditorialVideoBooted) return;
  window.kvEditorialVideoBooted = true;

  var SEL = 'video[data-kv-editorial-video]';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = null;

  /* Deja el video parado y en el fotograma cero: load() devuelve el elemento a
     su estado inicial, con lo que vuelve a verse el poster. */
  function freeze(v) {
    try { v.pause(); } catch (e) {}
    v.removeAttribute('autoplay');
    try { v.currentTime = 0; } catch (e) {}
    try { v.load(); } catch (e) {}
  }

  function play(v) {
    if (REDUCED.matches) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pause(v) {
    try { v.pause(); } catch (e) {}
  }

  function observer() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target); else pause(e.target);
      });
    }, { threshold: 0.2 });
    return io;
  }

  function mount(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SEL), function (v) {
      if (v.getAttribute('data-kv-video-ready') === 'true') return;
      v.setAttribute('data-kv-video-ready', 'true');
      v.muted = true;   /* iOS solo autoreproduce si el silencio va por propiedad */
      if (REDUCED.matches) { freeze(v); return; }
      var o = observer();
      if (o) o.observe(v); else play(v);
    });
  }

  function reduceChanged() {
    var list = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(list, function (v) {
      if (REDUCED.matches) {
        if (io) io.unobserve(v);
        freeze(v);
      } else {
        v.removeAttribute('data-kv-video-ready');
      }
    });
    if (!REDUCED.matches) mount(document);
  }

  if (REDUCED.addEventListener) REDUCED.addEventListener('change', reduceChanged);
  else if (REDUCED.addListener) REDUCED.addListener(reduceChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }

  /* Editor de temas: la seccion se repinta sin recargar la pagina. */
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-5050-luxe"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   KV · VIDEO EDITORIAL EN BUCLE  (bloques 50/50 y two-up)
   --------------------------------------------------------------------------
   Las cinco secciones kv-5050-* / kv-twoup incluyen este MISMO bloque; el flag
   de window hace que solo arranque el primer ejemplar que llegue.
     · Arranca por IntersectionObserver y PAUSA al salir de pantalla.
     · prefers-reduced-motion: no reproduce nada, se queda en el poster.
     · El poster esta siempre puesto: si el mp4 no carga se ve la imagen y no
       un hueco negro.
   ========================================================================== */
(function () {
  if (window.kvEditorialVideoBooted) return;
  window.kvEditorialVideoBooted = true;

  var SEL = 'video[data-kv-editorial-video]';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = null;

  /* Deja el video parado y en el fotograma cero: load() devuelve el elemento a
     su estado inicial, con lo que vuelve a verse el poster. */
  function freeze(v) {
    try { v.pause(); } catch (e) {}
    v.removeAttribute('autoplay');
    try { v.currentTime = 0; } catch (e) {}
    try { v.load(); } catch (e) {}
  }

  function play(v) {
    if (REDUCED.matches) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pause(v) {
    try { v.pause(); } catch (e) {}
  }

  function observer() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target); else pause(e.target);
      });
    }, { threshold: 0.2 });
    return io;
  }

  function mount(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SEL), function (v) {
      if (v.getAttribute('data-kv-video-ready') === 'true') return;
      v.setAttribute('data-kv-video-ready', 'true');
      v.muted = true;   /* iOS solo autoreproduce si el silencio va por propiedad */
      if (REDUCED.matches) { freeze(v); return; }
      var o = observer();
      if (o) o.observe(v); else play(v);
    });
  }

  function reduceChanged() {
    var list = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(list, function (v) {
      if (REDUCED.matches) {
        if (io) io.unobserve(v);
        freeze(v);
      } else {
        v.removeAttribute('data-kv-video-ready');
      }
    });
    if (!REDUCED.matches) mount(document);
  }

  if (REDUCED.addEventListener) REDUCED.addEventListener('change', reduceChanged);
  else if (REDUCED.addListener) REDUCED.addListener(reduceChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }

  /* Editor de temas: la seccion se repinta sin recargar la pagina. */
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-5050-nonstop"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   KV · VIDEO EDITORIAL EN BUCLE  (bloques 50/50 y two-up)
   --------------------------------------------------------------------------
   Las cinco secciones kv-5050-* / kv-twoup incluyen este MISMO bloque; el flag
   de window hace que solo arranque el primer ejemplar que llegue.
     · Arranca por IntersectionObserver y PAUSA al salir de pantalla.
     · prefers-reduced-motion: no reproduce nada, se queda en el poster.
     · El poster esta siempre puesto: si el mp4 no carga se ve la imagen y no
       un hueco negro.
   ========================================================================== */
(function () {
  if (window.kvEditorialVideoBooted) return;
  window.kvEditorialVideoBooted = true;

  var SEL = 'video[data-kv-editorial-video]';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = null;

  /* Deja el video parado y en el fotograma cero: load() devuelve el elemento a
     su estado inicial, con lo que vuelve a verse el poster. */
  function freeze(v) {
    try { v.pause(); } catch (e) {}
    v.removeAttribute('autoplay');
    try { v.currentTime = 0; } catch (e) {}
    try { v.load(); } catch (e) {}
  }

  function play(v) {
    if (REDUCED.matches) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pause(v) {
    try { v.pause(); } catch (e) {}
  }

  function observer() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target); else pause(e.target);
      });
    }, { threshold: 0.2 });
    return io;
  }

  function mount(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SEL), function (v) {
      if (v.getAttribute('data-kv-video-ready') === 'true') return;
      v.setAttribute('data-kv-video-ready', 'true');
      v.muted = true;   /* iOS solo autoreproduce si el silencio va por propiedad */
      if (REDUCED.matches) { freeze(v); return; }
      var o = observer();
      if (o) o.observe(v); else play(v);
    });
  }

  function reduceChanged() {
    var list = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(list, function (v) {
      if (REDUCED.matches) {
        if (io) io.unobserve(v);
        freeze(v);
      } else {
        v.removeAttribute('data-kv-video-ready');
      }
    });
    if (!REDUCED.matches) mount(document);
  }

  if (REDUCED.addEventListener) REDUCED.addEventListener('change', reduceChanged);
  else if (REDUCED.addListener) REDUCED.addListener(reduceChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }

  /* Editor de temas: la seccion se repinta sin recargar la pagina. */
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-5050-sanitize"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   KV · VIDEO EDITORIAL EN BUCLE  (bloques 50/50 y two-up)
   --------------------------------------------------------------------------
   Las cinco secciones kv-5050-* / kv-twoup incluyen este MISMO bloque; el flag
   de window hace que solo arranque el primer ejemplar que llegue.
     · Arranca por IntersectionObserver y PAUSA al salir de pantalla.
     · prefers-reduced-motion: no reproduce nada, se queda en el poster.
     · El poster esta siempre puesto: si el mp4 no carga se ve la imagen y no
       un hueco negro.
   ========================================================================== */
(function () {
  if (window.kvEditorialVideoBooted) return;
  window.kvEditorialVideoBooted = true;

  var SEL = 'video[data-kv-editorial-video]';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = null;

  /* Deja el video parado y en el fotograma cero: load() devuelve el elemento a
     su estado inicial, con lo que vuelve a verse el poster. */
  function freeze(v) {
    try { v.pause(); } catch (e) {}
    v.removeAttribute('autoplay');
    try { v.currentTime = 0; } catch (e) {}
    try { v.load(); } catch (e) {}
  }

  function play(v) {
    if (REDUCED.matches) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pause(v) {
    try { v.pause(); } catch (e) {}
  }

  function observer() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target); else pause(e.target);
      });
    }, { threshold: 0.2 });
    return io;
  }

  function mount(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SEL), function (v) {
      if (v.getAttribute('data-kv-video-ready') === 'true') return;
      v.setAttribute('data-kv-video-ready', 'true');
      v.muted = true;   /* iOS solo autoreproduce si el silencio va por propiedad */
      if (REDUCED.matches) { freeze(v); return; }
      var o = observer();
      if (o) o.observe(v); else play(v);
    });
  }

  function reduceChanged() {
    var list = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(list, function (v) {
      if (REDUCED.matches) {
        if (io) io.unobserve(v);
        freeze(v);
      } else {
        v.removeAttribute('data-kv-video-ready');
      }
    });
    if (!REDUCED.matches) mount(document);
  }

  if (REDUCED.addEventListener) REDUCED.addEventListener('change', reduceChanged);
  else if (REDUCED.addListener) REDUCED.addListener(reduceChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }

  /* Editor de temas: la seccion se repinta sin recargar la pagina. */
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-carousel-clean"] && !Shopify.designMode) return;
  try {
    
/* KV · carrusel 3-up. Vanilla, sin dependencias, sin librerias externas.
   Las cuatro secciones kv-carousel-* incluyen este mismo bloque; la guarda de
   customElements.get() evita que la segunda definicion lance. */
(function () {
  if (window.customElements && customElements.get('kv-carousel-3up')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KvCarousel3Up extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-kv-track]');
      if (!this.track || this.dataset.kvReady === 'true') return;
      this.dataset.kvReady = 'true';

      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-kv-slide]'));
      this.prevBtn = this.querySelector('[data-kv-prev]');
      this.nextBtn = this.querySelector('[data-kv-next]');
      this.dotsBox = this.querySelector('[data-kv-dots]');
      this.pages = 1;
      this.page = 0;

      this._sync = this._raf(this.sync.bind(this));
      this._build = this._raf(this.build.bind(this));

      this.track.addEventListener('scroll', this._sync, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.go.bind(this, -1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.go.bind(this, 1));

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this._build);
        this.ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._build);
      }
      this.build();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this._build);
    }

    _raf(fn) {
      var queued = false;
      return function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fn(); });
      };
    }

    get step() {
      if (this.slides.length > 1) {
        var d = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        if (d > 1) return d;
      }
      return this.track.clientWidth || 1;
    }

    get max() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    build() {
      if (!this.track) return;
      var pages = this.max <= 1 ? 1 : Math.max(1, Math.round(this.max / this.step) + 1);
      this.pages = pages;
      this.classList.toggle('is-single-page', pages <= 1);

      if (this.dotsBox && this.dotsBox.childElementCount !== pages) {
        this.dotsBox.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kv-3up__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', this.goTo.bind(this, i));
          this.dotsBox.appendChild(dot);
        }
      }
      this.sync();
    }

    go(delta) {
      this.goTo(this.page + delta);
    }

    goTo(index) {
      var page = Math.min(Math.max(index, 0), this.pages - 1);
      this.track.scrollTo({
        left: Math.min(page * this.step, this.max),
        behavior: REDUCED.matches ? 'instant' : 'smooth'
      });
    }

    sync() {
      if (!this.track) return;
      var x = this.track.scrollLeft;
      this.page = Math.min(this.pages - 1, Math.max(0, Math.round(x / this.step)));

      if (this.dotsBox) {
        var page = this.page;
        Array.prototype.forEach.call(this.dotsBox.children, function (dot, i) {
          var on = i === page;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      if (this.prevBtn) {
        var atStart = x <= 2;
        this.prevBtn.disabled = atStart;
        this.prevBtn.classList.toggle('is-disabled', atStart);
      }
      if (this.nextBtn) {
        var atEnd = x >= this.max - 2;
        this.nextBtn.disabled = atEnd;
        this.nextBtn.classList.toggle('is-disabled', atEnd);
      }
    }
  }

  customElements.define('kv-carousel-3up', KvCarousel3Up);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-carousel-detect"] && !Shopify.designMode) return;
  try {
    
/* KV · carrusel 3-up. Vanilla, sin dependencias, sin librerias externas.
   Las cuatro secciones kv-carousel-* incluyen este mismo bloque; la guarda de
   customElements.get() evita que la segunda definicion lance. */
(function () {
  if (window.customElements && customElements.get('kv-carousel-3up')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KvCarousel3Up extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-kv-track]');
      if (!this.track || this.dataset.kvReady === 'true') return;
      this.dataset.kvReady = 'true';

      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-kv-slide]'));
      this.prevBtn = this.querySelector('[data-kv-prev]');
      this.nextBtn = this.querySelector('[data-kv-next]');
      this.dotsBox = this.querySelector('[data-kv-dots]');
      this.pages = 1;
      this.page = 0;

      this._sync = this._raf(this.sync.bind(this));
      this._build = this._raf(this.build.bind(this));

      this.track.addEventListener('scroll', this._sync, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.go.bind(this, -1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.go.bind(this, 1));

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this._build);
        this.ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._build);
      }
      this.build();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this._build);
    }

    _raf(fn) {
      var queued = false;
      return function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fn(); });
      };
    }

    get step() {
      if (this.slides.length > 1) {
        var d = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        if (d > 1) return d;
      }
      return this.track.clientWidth || 1;
    }

    get max() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    build() {
      if (!this.track) return;
      var pages = this.max <= 1 ? 1 : Math.max(1, Math.round(this.max / this.step) + 1);
      this.pages = pages;
      this.classList.toggle('is-single-page', pages <= 1);

      if (this.dotsBox && this.dotsBox.childElementCount !== pages) {
        this.dotsBox.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kv-3up__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', this.goTo.bind(this, i));
          this.dotsBox.appendChild(dot);
        }
      }
      this.sync();
    }

    go(delta) {
      this.goTo(this.page + delta);
    }

    goTo(index) {
      var page = Math.min(Math.max(index, 0), this.pages - 1);
      this.track.scrollTo({
        left: Math.min(page * this.step, this.max),
        behavior: REDUCED.matches ? 'instant' : 'smooth'
      });
    }

    sync() {
      if (!this.track) return;
      var x = this.track.scrollLeft;
      this.page = Math.min(this.pages - 1, Math.max(0, Math.round(x / this.step)));

      if (this.dotsBox) {
        var page = this.page;
        Array.prototype.forEach.call(this.dotsBox.children, function (dot, i) {
          var on = i === page;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      if (this.prevBtn) {
        var atStart = x <= 2;
        this.prevBtn.disabled = atStart;
        this.prevBtn.classList.toggle('is-disabled', atStart);
      }
      if (this.nextBtn) {
        var atEnd = x >= this.max - 2;
        this.nextBtn.disabled = atEnd;
        this.nextBtn.classList.toggle('is-disabled', atEnd);
      }
    }
  }

  customElements.define('kv-carousel-3up', KvCarousel3Up);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-carousel-features"] && !Shopify.designMode) return;
  try {
    
/* KV · carrusel 3-up. Vanilla, sin dependencias, sin librerias externas.
   Las cuatro secciones kv-carousel-* incluyen este mismo bloque; la guarda de
   customElements.get() evita que la segunda definicion lance. */
(function () {
  if (window.customElements && customElements.get('kv-carousel-3up')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KvCarousel3Up extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-kv-track]');
      if (!this.track || this.dataset.kvReady === 'true') return;
      this.dataset.kvReady = 'true';

      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-kv-slide]'));
      this.prevBtn = this.querySelector('[data-kv-prev]');
      this.nextBtn = this.querySelector('[data-kv-next]');
      this.dotsBox = this.querySelector('[data-kv-dots]');
      this.pages = 1;
      this.page = 0;

      this._sync = this._raf(this.sync.bind(this));
      this._build = this._raf(this.build.bind(this));

      this.track.addEventListener('scroll', this._sync, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.go.bind(this, -1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.go.bind(this, 1));

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this._build);
        this.ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._build);
      }
      this.build();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this._build);
    }

    _raf(fn) {
      var queued = false;
      return function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fn(); });
      };
    }

    get step() {
      if (this.slides.length > 1) {
        var d = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        if (d > 1) return d;
      }
      return this.track.clientWidth || 1;
    }

    get max() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    build() {
      if (!this.track) return;
      var pages = this.max <= 1 ? 1 : Math.max(1, Math.round(this.max / this.step) + 1);
      this.pages = pages;
      this.classList.toggle('is-single-page', pages <= 1);

      if (this.dotsBox && this.dotsBox.childElementCount !== pages) {
        this.dotsBox.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kv-3up__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', this.goTo.bind(this, i));
          this.dotsBox.appendChild(dot);
        }
      }
      this.sync();
    }

    go(delta) {
      this.goTo(this.page + delta);
    }

    goTo(index) {
      var page = Math.min(Math.max(index, 0), this.pages - 1);
      this.track.scrollTo({
        left: Math.min(page * this.step, this.max),
        behavior: REDUCED.matches ? 'instant' : 'smooth'
      });
    }

    sync() {
      if (!this.track) return;
      var x = this.track.scrollLeft;
      this.page = Math.min(this.pages - 1, Math.max(0, Math.round(x / this.step)));

      if (this.dotsBox) {
        var page = this.page;
        Array.prototype.forEach.call(this.dotsBox.children, function (dot, i) {
          var on = i === page;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      if (this.prevBtn) {
        var atStart = x <= 2;
        this.prevBtn.disabled = atStart;
        this.prevBtn.classList.toggle('is-disabled', atStart);
      }
      if (this.nextBtn) {
        var atEnd = x >= this.max - 2;
        this.nextBtn.disabled = atEnd;
        this.nextBtn.classList.toggle('is-disabled', atEnd);
      }
    }
  }

  customElements.define('kv-carousel-3up', KvCarousel3Up);
})();

/* KV · <kv-video-card>: el video de la tarjeta arranca solo cuando la tarjeta
   entra en pantalla y se pausa al salir, para no tener 6 videos a la vez.
   Con prefers-reduced-motion no se reproduce nunca: se queda el poster.
   Solo lo incluyen los dos carruseles de video (highlights y features); la
   guarda de customElements.get() evita que la segunda definicion lance. */
(function () {
  if (window.customElements && customElements.get('kv-video-card')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KvVideoCard extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.dataset.kvReady === 'true') return;
      this.dataset.kvReady = 'true';
      this.inView = false;

      // Movimiento reducido: no se reproduce nunca. Se quita autoplay y se queda el poster.
      if (REDUCED.matches) {
        this.video.removeAttribute('autoplay');
        this.video.autoplay = false;
        this.video.loop = false;
        try { this.video.pause(); this.video.currentTime = 0; } catch (e) {}
        return;
      }

      // Sin IntersectionObserver se queda el autoplay nativo del markup.
      if (!('IntersectionObserver' in window)) return;

      var self = this;
      this.video.removeAttribute('autoplay');
      this.io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          self.inView = entries[i].isIntersecting;
        }
        self.update();
      }, { threshold: 0.25 });
      this.io.observe(this);

      this._onVis = function () { self.update(); };
      document.addEventListener('visibilitychange', this._onVis);
      this.update();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
    }

    // Unica regla: se reproduce si la tarjeta esta en pantalla y la pestana visible.
    update() {
      if (!this.video) return;
      if (this.inView && !document.hidden) {
        if (this.video.paused) {
          var p = this.video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      } else if (!this.video.paused) {
        try { this.video.pause(); } catch (e) {}
      }
    }
  }

  customElements.define('kv-video-card', KvVideoCard);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-carousel-highlights"] && !Shopify.designMode) return;
  try {
    
/* KV · carrusel 3-up. Vanilla, sin dependencias, sin librerias externas.
   Las cuatro secciones kv-carousel-* incluyen este mismo bloque; la guarda de
   customElements.get() evita que la segunda definicion lance. */
(function () {
  if (window.customElements && customElements.get('kv-carousel-3up')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KvCarousel3Up extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-kv-track]');
      if (!this.track || this.dataset.kvReady === 'true') return;
      this.dataset.kvReady = 'true';

      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-kv-slide]'));
      this.prevBtn = this.querySelector('[data-kv-prev]');
      this.nextBtn = this.querySelector('[data-kv-next]');
      this.dotsBox = this.querySelector('[data-kv-dots]');
      this.pages = 1;
      this.page = 0;

      this._sync = this._raf(this.sync.bind(this));
      this._build = this._raf(this.build.bind(this));

      this.track.addEventListener('scroll', this._sync, { passive: true });
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.go.bind(this, -1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.go.bind(this, 1));

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this._build);
        this.ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._build);
      }
      this.build();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this._build);
    }

    _raf(fn) {
      var queued = false;
      return function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fn(); });
      };
    }

    get step() {
      if (this.slides.length > 1) {
        var d = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        if (d > 1) return d;
      }
      return this.track.clientWidth || 1;
    }

    get max() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    build() {
      if (!this.track) return;
      var pages = this.max <= 1 ? 1 : Math.max(1, Math.round(this.max / this.step) + 1);
      this.pages = pages;
      this.classList.toggle('is-single-page', pages <= 1);

      if (this.dotsBox && this.dotsBox.childElementCount !== pages) {
        this.dotsBox.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kv-3up__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', this.goTo.bind(this, i));
          this.dotsBox.appendChild(dot);
        }
      }
      this.sync();
    }

    go(delta) {
      this.goTo(this.page + delta);
    }

    goTo(index) {
      var page = Math.min(Math.max(index, 0), this.pages - 1);
      this.track.scrollTo({
        left: Math.min(page * this.step, this.max),
        behavior: REDUCED.matches ? 'instant' : 'smooth'
      });
    }

    sync() {
      if (!this.track) return;
      var x = this.track.scrollLeft;
      this.page = Math.min(this.pages - 1, Math.max(0, Math.round(x / this.step)));

      if (this.dotsBox) {
        var page = this.page;
        Array.prototype.forEach.call(this.dotsBox.children, function (dot, i) {
          var on = i === page;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      if (this.prevBtn) {
        var atStart = x <= 2;
        this.prevBtn.disabled = atStart;
        this.prevBtn.classList.toggle('is-disabled', atStart);
      }
      if (this.nextBtn) {
        var atEnd = x >= this.max - 2;
        this.nextBtn.disabled = atEnd;
        this.nextBtn.classList.toggle('is-disabled', atEnd);
      }
    }
  }

  customElements.define('kv-carousel-3up', KvCarousel3Up);
})();

/* KV · <kv-video-card>: el video de la tarjeta arranca solo cuando la tarjeta
   entra en pantalla y se pausa al salir, para no tener 6 videos a la vez.
   Con prefers-reduced-motion no se reproduce nunca: se queda el poster.
   Solo lo incluyen los dos carruseles de video (highlights y features); la
   guarda de customElements.get() evita que la segunda definicion lance. */
(function () {
  if (window.customElements && customElements.get('kv-video-card')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class KvVideoCard extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.dataset.kvReady === 'true') return;
      this.dataset.kvReady = 'true';
      this.inView = false;

      // Movimiento reducido: no se reproduce nunca. Se quita autoplay y se queda el poster.
      if (REDUCED.matches) {
        this.video.removeAttribute('autoplay');
        this.video.autoplay = false;
        this.video.loop = false;
        try { this.video.pause(); this.video.currentTime = 0; } catch (e) {}
        return;
      }

      // Sin IntersectionObserver se queda el autoplay nativo del markup.
      if (!('IntersectionObserver' in window)) return;

      var self = this;
      this.video.removeAttribute('autoplay');
      this.io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          self.inView = entries[i].isIntersecting;
        }
        self.update();
      }, { threshold: 0.25 });
      this.io.observe(this);

      this._onVis = function () { self.update(); };
      document.addEventListener('visibilitychange', this._onVis);
      this.update();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
    }

    // Unica regla: se reproduce si la tarjeta esta en pantalla y la pestana visible.
    update() {
      if (!this.video) return;
      if (this.inView && !document.hidden) {
        if (this.video.paused) {
          var p = this.video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      } else if (!this.video.paused) {
        try { this.video.pause(); } catch (e) {}
      }
    }
  }

  customElements.define('kv-video-card', KvVideoCard);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-pdp-main"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   PDP MAIN — galeria, swatches, cantidad, acordeon y barra sticky.
   Sin dependencias. Todo cuelga de los data-kv-*: no toca nada de Refresh.
   Idempotente y re-lanzable con shopify:section:load (editor de temas).
   ========================================================================== */
(function () {
  'use strict';

  function once(el) {
    if (!el || el.getAttribute('data-kv-ready') === '1') return false;
    el.setAttribute('data-kv-ready', '1');
    return true;
  }

  function all(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ------------------------------------------------------------------ video */
  /* Un mando por cada <video> de la galeria: los del visor y los de la pantalla
     completa. Las clases y el aria se pintan SIEMPRE desde los eventos del
     propio elemento, nunca desde lo que creemos haberle pedido: si el navegador
     se niega a reproducir o a dar sonido, los botones lo cuentan de verdad.
     `sound` es el estado de sonido compartido por toda la galeria. */
  function makeVideo(box, sound) {
    if (!box) return null;
    var v = box.querySelector('video');
    if (!v) return null;

    var playBtn = box.querySelector('[data-kv-video-play]');
    var muteBtn = box.querySelector('[data-kv-video-mute]');
    var still = reducedMotion();
    var wanted = null; /* lo que pide la galeria; null = todavia sin decidir */
    var stopped = false; /* el visitante lo ha parado a mano */

    function say(btn, attr, pressed) {
      if (!btn) return;
      var text = btn.getAttribute(attr);
      if (text) btn.setAttribute('aria-label', text);
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    }

    function paint() {
      var playing = !v.paused && !v.ended;
      box.classList.toggle('is-playing', playing);
      box.classList.toggle('is-paused', !playing);
      box.classList.toggle('is-muted', !!v.muted);
      say(playBtn, playing ? 'data-label-pause' : 'data-label-play', playing);
      say(muteBtn, v.muted ? 'data-label-unmute' : 'data-label-mute', v.muted);
    }

    /* play() devuelve una promesa que se RECHAZA cuando la politica de autoplay
       del navegador no lo permite. Si el rechazo viene por llevar sonido, se
       vuelve a silencio y se reintenta una vez. Si ni asi arranca, se queda el
       poster y el boton en "Play": nunca un hueco negro ni un error suelto. */
    function attempt() {
      var p;
      try {
        p = v.play();
      } catch (e) {
        paint();
        return;
      }
      if (!p || !p.catch) return;
      p.catch(function () {
        if (v.muted) {
          paint();
          return;
        }
        v.muted = true;
        sound.on = false;
        sound.sync();
        var again;
        try {
          again = v.play();
        } catch (e2) {
          paint();
          return;
        }
        if (again && again.catch) again.catch(paint);
      });
    }

    /* La galeria enciende la pieza que se esta viendo y apaga las demas: sin
       esto sonarian los seis videos a la vez y se descargarian todos. */
    function setActive(on) {
      if (wanted === on) return;
      wanted = on;

      if (!on) {
        try {
          v.pause();
          if (v.readyState > 0) v.currentTime = 0;
        } catch (e) {
          /* rebobinar es un extra: si el navegador no deja, da igual */
        }
        paint();
        return;
      }

      /* Con movimiento reducido, o si el visitante lo paro a mano, se queda
         quieto en el poster hasta que el pulse Play. */
      if (still || stopped) {
        paint();
        return;
      }

      v.muted = !sound.on;
      attempt();
    }

    function syncSound() {
      v.muted = !sound.on;
      paint();
    }

    ['play', 'pause', 'ended', 'volumechange'].forEach(function (ev) {
      v.addEventListener(ev, paint);
    });

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (v.paused || v.ended) {
          stopped = false;
          attempt();
        } else {
          stopped = true;
          v.pause();
        }
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        /* Estaba en silencio -> el visitante quiere oirlo. La preferencia es de
           TODA la galeria: al cambiar de pieza o al abrir la pantalla completa
           no hay que volver a quitar el silencio. */
        sound.on = !!v.muted;
        sound.sync();
        /* Un clic es un gesto del visitante, el unico momento en que el
           navegador deja arrancar con sonido. Se aprovecha. */
        if (!stopped && (v.paused || v.ended)) attempt();
      });
    }

    /* A partir de aqui manda el JS: se quita el autoplay del marcado para que
       la pieza que se ve no siga sola cuando el visitante pase a otra. Sin JS el
       atributo se queda tal cual y el video arranca solo igualmente. */
    var hadAutoplay = v.hasAttribute('autoplay');
    v.autoplay = false;
    v.removeAttribute('autoplay');

    if (still) {
      /* prefers-reduced-motion: nada arranca solo. */
      try {
        v.pause();
        /* Solo la pieza que llevaba autoplay ha podido empezar a reproducirse
           antes de que llegase este script (va con defer), asi que solo a esa
           se la recarga para que vuelva a verse el POSTER. Recargar las demas
           las obligaria a pedir el .mp4 que su preload="none" esta evitando. */
        if (hadAutoplay) v.load();
      } catch (e) {
        /* si load() no esta disponible basta con el pause() */
      }
    }

    v.muted = true;
    paint();

    var handler = { setActive: setActive, syncSound: syncSound };
    sound.list.push(handler);
    return handler;
  }

  /* ---------------------------------------------------------------- galeria */
  function initGallery(root) {
    if (!once(root)) return;

    var viewer = root.querySelector('[data-kv-gallery-viewer]');
    var slides = all(root, '[data-kv-gallery-slide]');
    var thumbs = all(root, '[data-kv-gallery-thumb]');
    var dots = all(root, '[data-kv-gallery-dot]');
    var dotsTrack = root.querySelector('[data-kv-gallery-dots-track]');
    var dotsWindow = root.querySelector('[data-kv-gallery-dots]');
    var prev = root.querySelector('[data-kv-gallery-prev]');
    var next = root.querySelector('[data-kv-gallery-next]');
    var fsBtn = root.querySelector('[data-kv-gallery-fullscreen]');
    var modal = root.querySelector('[data-kv-gallery-modal]');
    var total = slides.length;
    var index = 0;
    var modalOpen = false;

    if (!viewer || !total) return;

    /* Sonido compartido por toda la galeria. Arranca en silencio, que es lo
       unico que los navegadores dejan reproducir solo. */
    var sound = { on: false, list: [] };
    sound.sync = function () {
      sound.list.forEach(function (h) {
        h.syncSound();
      });
    };

    var viewerVideos = slides.map(function (s) {
      return makeVideo(s.querySelector('[data-kv-video]'), sound);
    });

    /* Solo suena y solo se descarga la pieza que se esta viendo, y nunca
       mientras la pantalla completa esta abierta (ahi manda el video del modal).
       Apagar es inmediato; encender espera 120ms a que el carrusel se pare, para
       que al saltar de la primera pieza a la ultima no arranquen de paso todos
       los videos por los que el desplazamiento suave va pasando. */
    var videoTimer = null;
    function syncVideos() {
      viewerVideos.forEach(function (h, n) {
        if (h && (modalOpen || n !== index)) h.setActive(false);
      });

      window.clearTimeout(videoTimer);
      if (modalOpen) return;

      var target = index;
      videoTimer = window.setTimeout(function () {
        var h = viewerVideos[target];
        if (h && target === index && !modalOpen) h.setActive(true);
      }, 120);
    }

    function centerDots(i) {
      if (!dotsTrack || !dotsWindow) return;
      var slot = 16;
      var visible = Math.max(1, Math.floor(dotsWindow.clientWidth / slot));
      var max = Math.max(0, total - visible);
      var start = Math.min(max, Math.max(0, i - Math.floor(visible / 2)));
      dotsTrack.style.transform = 'translateX(' + -(start * slot) + 'px)';
    }

    function paint(i) {
      index = Math.min(total - 1, Math.max(0, i));
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === index);
        t.setAttribute('aria-selected', n === index ? 'true' : 'false');
        t.tabIndex = n === index ? 0 : -1;
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === total - 1;
      centerDots(index);
      syncVideos();
    }

    function goTo(i, smooth) {
      var target = Math.min(total - 1, Math.max(0, i));
      var slide = slides[target];
      if (!slide) return;
      var left = slide.offsetLeft - slides[0].offsetLeft;
      var from = viewer.scrollLeft;
      var soft = smooth !== false && !reducedMotion();

      try {
        viewer.scrollTo({ left: left, behavior: soft ? 'smooth' : 'auto' });
      } catch (e) {
        viewer.scrollLeft = left;
      }

      /* Red de seguridad: hay entornos (webviews, animaciones desactivadas por
         el sistema) donde el scroll suave se ignora sin lanzar error y la
         miniatura se quedaria marcada pero sin mover la imagen. Si a los 250ms
         no se ha movido ni un pixel, se salta en seco. */
      if (soft && left !== from) {
        window.setTimeout(function () {
          if (viewer.scrollLeft === from) viewer.scrollLeft = left;
        }, 250);
      }

      paint(target);
    }

    var ticking = false;
    viewer.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var w = viewer.clientWidth || 1;
          paint(Math.round(viewer.scrollLeft / w));
        });
      },
      { passive: true }
    );

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () {
        goTo(n);
      });
    });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        goTo(n);
      });
    });
    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    viewer.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(index + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(index - 1);
      }
    });

    if (modal) {
      var mSlides = all(modal, '[data-kv-gallery-modal-slide]');
      var mPrev = modal.querySelector('[data-kv-gallery-modal-prev]');
      var mNext = modal.querySelector('[data-kv-gallery-modal-next]');
      var mClose = modal.querySelector('[data-kv-gallery-modal-close]');
      var mBack = modal.querySelector('[data-kv-gallery-modal-backdrop]');
      var mCount = modal.querySelector('[data-kv-gallery-modal-counter]');
      var mIndex = 0;
      var lastFocus = null;

      /* Los videos del modal salen con preload="none" y sin autoplay: no pesan
         nada hasta que se abre la pantalla completa, y entonces arranca el que
         toca. Comparten el estado de sonido con el visor. */
      var modalVideos = mSlides.map(function (s) {
        return makeVideo(s.querySelector('[data-kv-video]'), sound);
      });

      var syncModalVideos = function () {
        modalVideos.forEach(function (h, n) {
          if (h) h.setActive(modalOpen && n === mIndex);
        });
      };

      var paintModal = function (i) {
        mIndex = Math.min(mSlides.length - 1, Math.max(0, i));
        mSlides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === mIndex);
        });
        if (mCount) mCount.textContent = mIndex + 1 + ' / ' + mSlides.length;
        if (mPrev) mPrev.disabled = mIndex === 0;
        if (mNext) mNext.disabled = mIndex === mSlides.length - 1;
        syncModalVideos();
      };

      var closeModal = function () {
        modal.classList.remove('is-open');
        modal.hidden = true;
        modalOpen = false;
        syncModalVideos();
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        goTo(mIndex, false);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      };

      var onKey = function (e) {
        if (e.key === 'Escape') closeModal();
        else if (e.key === 'ArrowRight') paintModal(mIndex + 1);
        else if (e.key === 'ArrowLeft') paintModal(mIndex - 1);
      };

      var openModal = function () {
        lastFocus = document.activeElement;
        modal.hidden = false;
        modal.classList.add('is-open');
        modalOpen = true;
        syncVideos();
        document.documentElement.style.overflow = 'hidden';
        paintModal(index);
        document.addEventListener('keydown', onKey);
        if (mClose) mClose.focus();
      };

      if (fsBtn) fsBtn.addEventListener('click', openModal);
      if (mClose) mClose.addEventListener('click', closeModal);
      if (mBack) mBack.addEventListener('click', closeModal);
      if (mPrev) {
        mPrev.addEventListener('click', function () {
          paintModal(mIndex - 1);
        });
      }
      if (mNext) {
        mNext.addEventListener('click', function () {
          paintModal(mIndex + 1);
        });
      }
    } else if (fsBtn) {
      fsBtn.hidden = true;
    }

    root.kvGoTo = goTo;
    paint(0);
    window.addEventListener('resize', function () {
      centerDots(index);
    });
  }

  /* --------------------------------------------------------------- swatches */
  function initSwatches(root) {
    if (!once(root)) return;

    var scope = root.closest('[data-kv-pdp]') || document;
    var buttons = all(root, '[data-kv-swatch]');
    var nameOuts = all(scope, '[data-kv-color-name]');
    var modelOuts = all(scope, '[data-kv-model]');
    var idInput = scope.querySelector('[data-kv-variant-id]');
    var priceOut = scope.querySelector('[data-kv-price]');
    var wasOut = scope.querySelector('[data-kv-price-was]');
    var saveOut = scope.querySelector('[data-kv-price-save]');
    var atc = scope.querySelector('[data-kv-atc]');
    var stickyBtn = document.querySelector('[data-kv-sticky-atc] [data-kv-sticky-btn]');
    var stickyPrice = document.querySelector('[data-kv-sticky-price]');
    var gallery = scope.querySelector('[data-kv-gallery]');
    var addLabel = (atc && atc.getAttribute('data-label-default')) || 'Add to Cart';
    var outLabel = (atc && atc.getAttribute('data-label-soldout')) || 'Sold out';

    function setLabel(btn, text) {
      if (!btn) return;
      var span = btn.querySelector('span');
      if (span) span.textContent = text;
      else btn.textContent = text;
    }

    /* La primera foto de la galeria (el hero) cambia a la foto del color elegido.
       Se cambian a la vez el slide grande, su miniatura y su copia del modal. */
    var heroSlide = gallery ? gallery.querySelector('[data-kv-gallery-slide][data-kv-kind="image"]') : null;
    var heroIndex = heroSlide ? all(gallery, '[data-kv-gallery-slide]').indexOf(heroSlide) : -1;
    function applyHero(src, jump) {
      if (!gallery || !heroSlide || !src) return;
      var targets = [heroSlide.querySelector('img.kv-gallery__img')];
      var thumb = all(gallery, '[data-kv-gallery-thumb]')[heroIndex];
      if (thumb) targets.push(thumb.querySelector('img'));
      var mslide = all(gallery, '[data-kv-gallery-modal-slide]')[heroIndex];
      if (mslide) targets.push(mslide.querySelector('img'));
      targets.forEach(function (im) {
        if (!im || im.getAttribute('src') === src) return;
        im.removeAttribute('srcset');
        im.src = src;
      });
      if (jump && gallery.kvGoTo && heroIndex > -1) gallery.kvGoTo(heroIndex);
    }
    /* Precarga las fotos de los otros colores la primera vez que el visitante
       se acerca al selector, para que el cambio sea instantaneo. */
    var preloaded = false;
    function preloadHeroes() {
      if (preloaded) return;
      preloaded = true;
      buttons.forEach(function (b) {
        if (b.dataset.heroSrc) { var im = new Image(); im.src = b.dataset.heroSrc; }
      });
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, preloadHeroes, { passive: true, once: true });
    });
    /* Si la pagina abre ya con un color que no es el primero (?variant=...),
       el hero debe ser el de ese color desde el principio. */
    var initial = buttons.filter(function (b) { return b.classList.contains('is-selected'); })[0];
    if (initial && initial.dataset.heroSrc && buttons.indexOf(initial) > 0) applyHero(initial.dataset.heroSrc, false);

    function select(btn) {
      buttons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });

      var d = btn.dataset;
      if (d.colorName) nameOuts.forEach(function (el) { el.textContent = d.colorName; });
      if (d.sku) modelOuts.forEach(function (el) { el.textContent = d.sku; });
      if (idInput && d.variantId) idInput.value = d.variantId;
      if (priceOut && d.price) priceOut.textContent = d.price;
      if (stickyPrice && d.price) stickyPrice.textContent = d.price;

      if (wasOut) {
        if (d.compare) {
          wasOut.textContent = d.compare;
          wasOut.hidden = false;
        } else {
          wasOut.hidden = true;
        }
      }
      if (saveOut) {
        if (d.save) {
          saveOut.textContent = d.save;
          saveOut.hidden = false;
        } else {
          saveOut.hidden = true;
        }
      }

      var available = d.available !== 'false';
      [atc, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !available;
        b.setAttribute('aria-disabled', available ? 'false' : 'true');
        setLabel(b, available ? addLabel : outLabel);
      });

      if (gallery && gallery.kvGoTo && d.mediaIndex) {
        gallery.kvGoTo(parseInt(d.mediaIndex, 10) - 1);
      } else if (d.heroSrc) {
        applyHero(d.heroSrc, true);
      }

      if (d.variantId && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', d.variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {
          /* si la URL no se puede reescribir da igual: manda el input del form */
        }
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select(btn);
      });
      btn.addEventListener('keydown', function (e) {
        var i = buttons.indexOf(btn);
        var target = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') target = buttons[i + 1];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') target = buttons[i - 1];
        if (target) {
          e.preventDefault();
          target.focus();
          select(target);
        }
      });
    });
  }

  /* --------------------------------------------------------------- cantidad */
  function initQty(root) {
    if (!once(root)) return;

    var input = root.querySelector('[data-kv-qty-input]');
    var minus = root.querySelector('[data-kv-qty-minus]');
    var plus = root.querySelector('[data-kv-qty-plus]');
    var error = root.parentNode ? root.parentNode.querySelector('[data-kv-qty-error]') : null;
    if (!input) return;

    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;

    function say(msg) {
      if (error) error.textContent = msg || '';
    }

    function sync() {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = min;
      v = Math.min(max, Math.max(min, v));
      input.value = v;
      if (minus) minus.disabled = v <= min;
      if (plus) plus.disabled = v >= max;
    }

    function step(delta) {
      var v = parseInt(input.value, 10) || min;
      var to = v + delta;
      if (to < min) {
        say(root.getAttribute('data-message-min') || '');
        return;
      }
      if (to > max) {
        say(root.getAttribute('data-message-max') || '');
        return;
      }
      say('');
      input.value = to;
      sync();
    }

    if (minus) {
      minus.addEventListener('click', function () {
        step(-1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        step(1);
      });
    }
    input.addEventListener('change', function () {
      say('');
      sync();
    });
    sync();
  }

  /* --------------------------------------------------------------- acordeon */
  function initAccordion(root) {
    if (!once(root)) return;

    all(root, '[data-kv-acc-trigger]').forEach(function (trigger) {
      var item = trigger.closest('[data-kv-acc-item]');
      var panel = item ? item.querySelector('[data-kv-acc-panel]') : null;
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });
  }

  /* ----------------------------------------------------------- barra sticky */
  function initSticky(bar) {
    if (!once(bar)) return;

    /* getElementById y no querySelector: el id lleva dentro section.id, que en
       el editor de temas puede empezar por un digito y romper el selector. */
    var id = bar.getAttribute('data-kv-sticky-watch');
    var watch = id ? document.getElementById(id) : null;
    if (!watch) return;

    var shown = null;
    function show(on) {
      if (shown === on) return;
      shown = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    /* La barra sale cuando el ATC principal ya ha quedado por encima del
       viewport. Se mide con scroll + rAF y no con IntersectionObserver: hay
       entornos (webviews, pestanas en segundo plano) donde el observer no
       llega a disparar nunca y la barra se quedaria muerta para siempre.
       Una sola lectura por frame, y solo si el scroll se ha movido. */
    var ticking = false;
    function check() {
      ticking = false;
      show(watch.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  function boot(scope) {
    var root = scope || document;
    all(root, '[data-kv-gallery]').forEach(initGallery);
    all(root, '[data-kv-swatches]').forEach(initSwatches);
    all(root, '[data-kv-qty]').forEach(initQty);
    all(root, '[data-kv-accordion]').forEach(initAccordion);
    all(root, '[data-kv-sticky-atc]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();

  /* ---------------------------------------------------------------------
     Carrusel de resenas bajo Add to Cart: scroll-snap nativo + puntos + flechas
     + autoplay suave (se pausa al tocar/pasar el raton; respeta reduced-motion).
     Idempotente y re-lanzable con shopify:section:load.
     --------------------------------------------------------------------- */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function initSlider(root) {
      var sliders = (root || document).querySelectorAll('[data-kv-rslider]');
      Array.prototype.forEach.call(sliders, function (el) {
        if (el.hasAttribute('data-kv-rslider-init')) return;
        el.setAttribute('data-kv-rslider-init', '');
        var track = el.querySelector('[data-kv-rslider-track]');
        var cards = track ? track.querySelectorAll('.kv-rslider__card') : [];
        var dotsBox = el.querySelector('[data-kv-rslider-dots]');
        var prev = el.querySelector('[data-kv-rslider-prev]');
        var next = el.querySelector('[data-kv-rslider-next]');
        var playBtn = el.querySelector('[data-kv-rslider-play]');
        /* Citas largas: boton Read more / Read less por tarjeta cuando el recorte de 6 lineas actua */
        Array.prototype.forEach.call(cards, function (card) {
          var q = card.querySelector('.kv-rslider__quote');
          if (!q || card.querySelector('.kv-rslider__more')) return;
          function check() {
            if (q.classList.contains('is-open')) return;
            if (q.scrollHeight > q.clientHeight + 2 && !card.querySelector('.kv-rslider__more')) {
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'kv-rslider__more'; b.textContent = 'Read more'; b.setAttribute('aria-expanded', 'false');
              b.addEventListener('click', function () {
                var open = q.classList.toggle('is-open');
                b.textContent = open ? 'Read less' : 'Read more';
                b.setAttribute('aria-expanded', open ? 'true' : 'false');
              });
              q.insertAdjacentElement('afterend', b);
            }
          }
          check();
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
          window.addEventListener('load', check);
        });
        if (!track || cards.length < 2) return;
        var current = 0, dots = [], timer = null;
        /* estados de pausa independientes: raton, foco, bloque seleccionado en el editor,
           parada manual (boton) y pausa temporal tras interaccion */
        var hovered = false, focused = false, editing = false, stopped = false, resumeAt = 0;
        function step() { return cards[1].offsetLeft - cards[0].offsetLeft; }
        function maxScroll() { return track.scrollWidth - track.clientWidth; }
        function goTo(i, smooth) {
          i = Math.max(0, Math.min(cards.length - 1, i));
          var left = Math.min(cards[i].offsetLeft - cards[0].offsetLeft, maxScroll());
          track.scrollTo({ left: left, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
        }
        function setActive(i) {
          if (i === current) return;
          current = i;
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
          if (prev) prev.disabled = i === 0;
          if (next) next.disabled = i === cards.length - 1;
        }
        function holdOff(ms) { resumeAt = Date.now() + ms; }
        if (dotsBox) {
          Array.prototype.forEach.call(cards, function (_, k) {
            var d = document.createElement('button');
            d.type = 'button'; d.className = 'kv-rslider__dot' + (k === 0 ? ' is-active' : '');
            d.setAttribute('role', 'tab'); d.setAttribute('aria-label', 'Review ' + (k + 1)); d.setAttribute('aria-selected', k === 0 ? 'true' : 'false');
            d.addEventListener('click', function () { holdOff(8000); goTo(k); });
            dotsBox.appendChild(d); dots.push(d);
          });
        }
        if (prev) { prev.disabled = true; prev.addEventListener('click', function () { holdOff(8000); goTo(current - 1); }); }
        if (next) next.addEventListener('click', function () { holdOff(8000); goTo(current + 1); });
        var raf = null;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = null;
            var st = step(); if (st <= 0) return;
            /* al final del scroll la ultima tarjeta cuenta como activa aunque no alinee exacto */
            setActive(track.scrollLeft >= maxScroll() - 2 ? cards.length - 1 : Math.round(track.scrollLeft / st));
          });
        }, { passive: true });
        /* autoplay */
        var delay = parseInt(el.getAttribute('data-kv-rslider-autoplay'), 10) || 0;
        function tick() {
          if (document.hidden || hovered || focused || editing || stopped || Date.now() < resumeAt) return;
          goTo(current === cards.length - 1 ? 0 : current + 1);
        }
        if (delay && !reduce) {
          timer = window.setInterval(tick, delay);
          el.addEventListener('mouseenter', function () { hovered = true; });
          el.addEventListener('mouseleave', function () { hovered = false; });
          el.addEventListener('focusin', function () { focused = true; });
          el.addEventListener('focusout', function () { focused = false; });
          track.addEventListener('touchstart', function () { holdOff(10000); }, { passive: true });
          track.addEventListener('pointerdown', function () { holdOff(10000); }, { passive: true });
          if (playBtn) {
            playBtn.addEventListener('click', function () {
              stopped = !stopped;
              playBtn.setAttribute('aria-pressed', stopped ? 'true' : 'false');
              playBtn.setAttribute('aria-label', stopped ? 'Resume auto-advance' : 'Pause auto-advance');
              track.setAttribute('aria-live', stopped ? 'polite' : 'off');
            });
          }
          track.setAttribute('aria-live', 'off');
        } else if (playBtn) {
          playBtn.hidden = true;
        }
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); holdOff(8000); goTo(current + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); holdOff(8000); goTo(current - 1); }
        });
        /* editor de temas: llevar la vista a la resena seleccionada y no moverse mientras se edita */
        el.addEventListener('shopify:block:select', function (e) {
          var li = e.target && e.target.closest ? e.target.closest('.kv-rslider__card') : null;
          var k = Array.prototype.indexOf.call(cards, li);
          if (k > -1) { editing = true; goTo(k, false); }
        });
        el.addEventListener('shopify:block:deselect', function () { editing = false; });
        function onResize() { goTo(current, false); }
        window.addEventListener('resize', onResize);
        el.kvRsliderDestroy = function () {
          if (timer) window.clearInterval(timer);
          window.removeEventListener('resize', onResize);
        };
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSlider(document); });
    } else {
      initSlider(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initSlider(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-kv-rslider-init]'), function (el) {
        if (el.kvRsliderDestroy) el.kvRsliderDestroy();
      });
    });
  })();

  /* ---------------------------------------------------------------------
     Descripcion corta: Read more / Read less. Solo se colapsa si el texto
     desborda de verdad; si cabe entero no se pinta ni el degradado ni el
     boton. Textos literales del original.
     --------------------------------------------------------------------- */
  (function () {
    /* Medicion robusta: se repite cuando llegan las fuentes y el CSS (evento load),
       al cambiar el ancho y tras re-render del editor de temas. Asi nunca se queda
       "cabe entero" por haber medido antes de que se aplicara la hoja de estilo. */
    function measureShort(box) {
      var text = box.querySelector('[data-kv-short-text]');
      if (!text) return;
      if (box.classList.contains('is-expanded')) return; /* abierto por el usuario: no tocar */
      /* Se colapsa PRIMERO y se mide despues: sin el atributo el texto va entero
         y clientHeight == scrollHeight. */
      box.setAttribute('data-kv-short-ready', '');
      if (text.scrollHeight <= text.clientHeight + 1) {
        box.removeAttribute('data-kv-short-ready'); /* cabe entero: sin recorte ni boton */
      }
    }
    function measureAll(root) {
      var boxes = (root || document).querySelectorAll('[data-kv-short]');
      Array.prototype.forEach.call(boxes, measureShort);
    }
    function initShort(root) {
      var boxes = (root || document).querySelectorAll('[data-kv-short]');
      Array.prototype.forEach.call(boxes, function (box) {
        var btn = box.querySelector('[data-kv-short-toggle]');
        if (!btn) return;
        if (!box.hasAttribute('data-kv-short-init')) {
          box.setAttribute('data-kv-short-init', '');
          btn.addEventListener('click', function () {
            var open = box.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            btn.textContent = open ? 'Read less' : 'Read more';
          });
        }
        measureShort(box);
        /* Segunda pasada tras pintar: cubre CSS aplicado un frame despues */
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { measureShort(box); });
        });
      });
    }
    var resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { measureAll(document); }, 120);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initShort(document); });
    } else {
      initShort(document);
    }
    window.addEventListener('load', function () { measureAll(document); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { measureAll(document); });
    }
    window.addEventListener('resize', onResize);
    document.addEventListener('shopify:section:load', function (e) { initShort(e.target); });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-reviews-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root) {
      var sliders = (root || document).querySelectorAll('[data-kv-rgrid]');
      Array.prototype.forEach.call(sliders, function (el) {
        if (el.hasAttribute('data-kv-rgrid-init')) return;
        el.setAttribute('data-kv-rgrid-init', '');
        var track = el.querySelector('[data-kv-rgrid-track]');
        var cards = track ? track.querySelectorAll('.kv-rgrid__card') : [];
        var dotsBox = el.querySelector('[data-kv-rgrid-dots]');
        var prev = el.querySelector('[data-kv-rgrid-prev]');
        var next = el.querySelector('[data-kv-rgrid-next]');
        /* Read more por tarjeta cuando la cita se recorta */
        Array.prototype.forEach.call(cards, function (card) {
          var q = card.querySelector('.kv-rgrid__quote');
          if (!q) return;
          function check() {
            if (q.classList.contains('is-open') || card.querySelector('.kv-rgrid__more')) return;
            if (q.scrollHeight > q.clientHeight + 2) {
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'kv-rgrid__more'; b.textContent = 'Read more'; b.setAttribute('aria-expanded', 'false');
              b.addEventListener('click', function () {
                var open = q.classList.toggle('is-open');
                b.textContent = open ? 'Read less' : 'Read more';
                b.setAttribute('aria-expanded', open ? 'true' : 'false');
              });
              q.insertAdjacentElement('afterend', b);
            }
          }
          check();
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
          window.addEventListener('load', check);
        });
        if (!track || cards.length < 2) return;
        var current = 0, dots = [];
        function step() { return cards[1].offsetLeft - cards[0].offsetLeft; }
        function maxScroll() { return track.scrollWidth - track.clientWidth; }
        function goTo(i, smooth) {
          i = Math.max(0, Math.min(cards.length - 1, i));
          var left = Math.min(cards[i].offsetLeft - cards[0].offsetLeft, maxScroll());
          track.scrollTo({ left: left, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
        }
        function setActive(i) {
          if (i === current) return;
          current = i;
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
          if (prev) prev.disabled = i === 0;
          if (next) next.disabled = i === cards.length - 1;
        }
        if (dotsBox) {
          Array.prototype.forEach.call(cards, function (_, k) {
            var d = document.createElement('button');
            d.type = 'button'; d.className = 'kv-rgrid__dot' + (k === 0 ? ' is-active' : '');
            d.setAttribute('role', 'tab'); d.setAttribute('aria-label', 'Review ' + (k + 1)); d.setAttribute('aria-selected', k === 0 ? 'true' : 'false');
            d.addEventListener('click', function () { goTo(k); });
            dotsBox.appendChild(d); dots.push(d);
          });
        }
        if (prev) { prev.disabled = true; prev.addEventListener('click', function () { goTo(current - 1); }); }
        if (next) next.addEventListener('click', function () { goTo(current + 1); });
        var raf = null;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = null;
            var st = step(); if (st <= 0) return;
            setActive(track.scrollLeft >= maxScroll() - 2 ? cards.length - 1 : Math.round(track.scrollLeft / st));
          });
        }, { passive: true });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        });
        el.addEventListener('shopify:block:select', function (e) {
          var li = e.target && e.target.closest ? e.target.closest('.kv-rgrid__card') : null;
          var k = Array.prototype.indexOf.call(cards, li);
          if (k > -1) goTo(k, false);
        });
        function onResize() { goTo(current, false); }
        window.addEventListener('resize', onResize);
        el.kvRgridDestroy = function () { window.removeEventListener('resize', onResize); };
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-kv-rgrid-init]'), function (el) { if (el.kvRgridDestroy) el.kvRgridDestroy(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-twoup"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   KV · VIDEO EDITORIAL EN BUCLE  (bloques 50/50 y two-up)
   --------------------------------------------------------------------------
   Las cinco secciones kv-5050-* / kv-twoup incluyen este MISMO bloque; el flag
   de window hace que solo arranque el primer ejemplar que llegue.
     · Arranca por IntersectionObserver y PAUSA al salir de pantalla.
     · prefers-reduced-motion: no reproduce nada, se queda en el poster.
     · El poster esta siempre puesto: si el mp4 no carga se ve la imagen y no
       un hueco negro.
   ========================================================================== */
(function () {
  if (window.kvEditorialVideoBooted) return;
  window.kvEditorialVideoBooted = true;

  var SEL = 'video[data-kv-editorial-video]';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = null;

  /* Deja el video parado y en el fotograma cero: load() devuelve el elemento a
     su estado inicial, con lo que vuelve a verse el poster. */
  function freeze(v) {
    try { v.pause(); } catch (e) {}
    v.removeAttribute('autoplay');
    try { v.currentTime = 0; } catch (e) {}
    try { v.load(); } catch (e) {}
  }

  function play(v) {
    if (REDUCED.matches) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function pause(v) {
    try { v.pause(); } catch (e) {}
  }

  function observer() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target); else pause(e.target);
      });
    }, { threshold: 0.2 });
    return io;
  }

  function mount(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SEL), function (v) {
      if (v.getAttribute('data-kv-video-ready') === 'true') return;
      v.setAttribute('data-kv-video-ready', 'true');
      v.muted = true;   /* iOS solo autoreproduce si el silencio va por propiedad */
      if (REDUCED.matches) { freeze(v); return; }
      var o = observer();
      if (o) o.observe(v); else play(v);
    });
  }

  function reduceChanged() {
    var list = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(list, function (v) {
      if (REDUCED.matches) {
        if (io) io.unobserve(v);
        freeze(v);
      } else {
        v.removeAttribute('data-kv-video-ready');
      }
    });
    if (!REDUCED.matches) mount(document);
  }

  if (REDUCED.addEventListener) REDUCED.addEventListener('change', reduceChanged);
  else if (REDUCED.addListener) REDUCED.addListener(reduceChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }

  /* Editor de temas: la seccion se repinta sin recargar la pagina. */
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root) {
      var sections = (root || document).querySelectorAll('[data-kv-ugc]');
      Array.prototype.forEach.call(sections, function (el) {
        if (el.hasAttribute('data-kv-ugc-init')) return;
        el.setAttribute('data-kv-ugc-init', '');
        var track = el.querySelector('[data-kv-ugc-track]');
        var cards = track ? Array.prototype.slice.call(track.querySelectorAll('.kv-ugc__card')) : [];
        var prev = el.querySelector('[data-kv-ugc-prev]');
        var next = el.querySelector('[data-kv-ugc-next]');
        if (!track || !cards.length) return;
        var autoplay = el.hasAttribute('data-kv-ugc-autoplay') && !reduce;
        var perView = 1, page = 0, inView = false, autoCard = null;

        function parts(card) {
          return { btn: card.querySelector('[data-kv-ugc-play]'), player: card.querySelector('[data-kv-ugc-player]'), video: card.querySelector('video') };
        }
        function showPoster(card) {
          var p = parts(card); if (!p.video) return;
          p.video.pause();
          if (p.player) p.player.hidden = true;
          if (p.btn) p.btn.hidden = false;
          card.classList.remove('is-auto');
        }
        function stopOthers(except) { cards.forEach(function (c) { if (c !== except) showPoster(c); }); }
        function startVideo(card, muted) {
          var p = parts(card); if (!p.video) return;
          if (p.player) p.player.hidden = false;
          if (p.btn) p.btn.hidden = true;
          p.video.muted = muted;
          if (p.video.getAttribute('preload') === 'none') p.video.setAttribute('preload', 'auto');
          var pr = p.video.play();
          if (pr && pr.catch) pr.catch(function () { if (!muted) { p.video.muted = true; p.video.play(); } });
        }
        /* tocar la caratula: reproduce ESE video con sonido */
        cards.forEach(function (card) {
          var p = parts(card);
          if (!p.btn || !p.player || !p.video) return;
          p.btn.addEventListener('click', function () { stopOthers(card); card.classList.remove('is-auto'); startVideo(card, false); });
          p.video.addEventListener('ended', function () { if (!p.video.loop) showPoster(card); });
        });

        /* paginacion: perView tarjetas por pagina; solo la primera de cada pagina es punto de snap */
        function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
        function maxScroll() { return track.scrollWidth - track.clientWidth; }
        /* inicios de pagina: 0, perView, 2*perView... y, si sobran tarjetas, una ultima pagina
           alineada al final (cards.length - perView) para que nunca quede hueco vacio */
        var starts = [0];
        function pages() { return starts.length; }
        function computePerView() {
          var st = step(); var w = track.clientWidth;
          perView = st > 0 ? Math.max(1, Math.round(w / st)) : 1;
          starts = [];
          for (var i = 0; i + perView <= cards.length; i += perView) starts.push(i);
          var lastStart = Math.max(0, cards.length - perView);
          if (starts.indexOf(lastStart) === -1) starts.push(lastStart);
          if (!starts.length) starts = [0];
          cards.forEach(function (c, i) { c.style.scrollSnapAlign = starts.indexOf(i) > -1 ? 'start' : 'none'; });
        }
        function firstOfPage(pg) { return starts[Math.max(0, Math.min(starts.length - 1, pg))]; }
        function goToPage(pg, smooth) {
          pg = Math.max(0, Math.min(pages() - 1, pg));
          var left = Math.min(cards[firstOfPage(pg)].offsetLeft - cards[0].offsetLeft, maxScroll());
          track.scrollTo({ left: left, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
        }
        /* autoplay en silencio del video de la izquierda de la pagina visible */
        function syncAutoplay() {
          if (!autoplay) return;
          var target = inView ? cards[firstOfPage(page)] : null;
          if (target === autoCard) return;
          if (autoCard) showPoster(autoCard);
          autoCard = target;
          if (autoCard) {
            var p = parts(autoCard);
            if (!p.video) return;
            /* si el usuario esta viendo otro con sonido, no lo interrumpimos */
            var manual = cards.some(function (c) { var q = parts(c); return c !== autoCard && q.video && !q.video.paused && !q.video.muted; });
            if (manual) { autoCard = null; return; }
            autoCard.classList.add('is-auto');
            startVideo(autoCard, true);
          }
        }
        function update() {
          var st = step(); if (st <= 0) return;
          var pos = track.scrollLeft / st, best = 0;
          for (var i = 1; i < starts.length; i++) { if (Math.abs(starts[i] - pos) < Math.abs(starts[best] - pos)) best = i; }
          page = best;
          if (prev) prev.hidden = page === 0;
          if (next) next.hidden = page >= pages() - 1;
          syncAutoplay();
        }
        if (prev) prev.addEventListener('click', function () { goToPage(page - 1); });
        if (next) next.addEventListener('click', function () { goToPage(page + 1); });
        var raf = null;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () { raf = null; update(); });
        }, { passive: true });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); goToPage(page + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); goToPage(page - 1); }
        });
        el.addEventListener('shopify:block:select', function (e) {
          var li = e.target && e.target.closest ? e.target.closest('.kv-ugc__card') : null;
          var k = cards.indexOf(li);
          if (k > -1) goToPage(Math.floor(k / perView), false);
        });
        /* en pantalla / fuera de pantalla */
        var io = null;
        if (window.IntersectionObserver) {
          io = new IntersectionObserver(function (entries) {
            inView = entries.some(function (en) { return en.isIntersecting; });
            syncAutoplay();
          }, { threshold: 0.35 });
          io.observe(track);
        } else { inView = true; }
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { cards.forEach(function (c) { var p = parts(c); if (p.video) p.video.pause(); }); }
          else if (autoCard) { var p = parts(autoCard); if (p.video) p.video.play(); }
        });
        function onResize() { computePerView(); update(); }
        window.addEventListener('resize', onResize);
        el.kvUgcDestroy = function () {
          window.removeEventListener('resize', onResize);
          if (io) io.disconnect();
          cards.forEach(showPoster);
        };
        computePerView(); update();
        window.requestAnimationFrame(function () { window.requestAnimationFrame(onResize); });
        window.addEventListener('load', onResize);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
        if (window.ResizeObserver) { var ro = new ResizeObserver(function () { onResize(); }); ro.observe(track); }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-kv-ugc-init]'), function (el) { if (el.kvUgcDestroy) el.kvUgcDestroy(); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
